"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalButtons = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _ModalButtons = require("./ModalButtons.types");
require("./ModalButtons.scss");
const ModalButtons = _ref => {
  let {
    primary,
    secondary,
    cancel
  } = _ref;
  const buttonsCount = [primary, secondary, cancel].filter(b => !!b).length;
  if (!buttonsCount) {
    return null;
  }
  const hasOnlyOneButton = buttonsCount === 1;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-Modal-Buttons', {
      ['cds-Modal-Buttons--Center']: hasOnlyOneButton
    })
  }, cancel && /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({
    id: "modal-cancel-button",
    className: "cds-Modal-Button--Cancel",
    styleType: _Button.BUTTON_STYLE_TYPE.ghost,
    type: cancel.type || _Button.BUTTON_TYPE.button,
    onClick: event => {
      cancel.onClick?.(event);
    },
    "aria-label": cancel.label,
    tabIndex: _ModalButtons.MODAL_BUTTON_SELECT_PRIORITIES.cancel,
    isLoading: cancel.isLoading,
    isDisabled: cancel.isDisabled
  }, cancel.icon && {
    iconPosition: _Button.BUTTON_ICON_POSITION.left
  }), cancel.icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    size: cancel.iconSize,
    name: cancel.icon
  }), cancel.label), secondary && /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({
    id: "modal-secondary-button",
    className: "cds-Modal-Button--Secondary",
    styleType: _Button.BUTTON_STYLE_TYPE.light,
    type: secondary.type || _Button.BUTTON_TYPE.button,
    onClick: event => secondary.onClick?.(event),
    "aria-label": secondary.label,
    tabIndex: _ModalButtons.MODAL_BUTTON_SELECT_PRIORITIES.secondary,
    isLoading: secondary.isLoading,
    isDisabled: secondary.isDisabled
  }, secondary.icon && {
    iconPosition: _Button.BUTTON_ICON_POSITION.left
  }), secondary.icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    size: secondary.iconSize,
    name: secondary.icon
  }), secondary.label), primary && /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({
    id: "modal-primary-button",
    className: "cds-Modal-Button--Primary",
    styleType: _Button.BUTTON_STYLE_TYPE.primary,
    type: primary.type || _Button.BUTTON_TYPE.button,
    onClick: event => primary.onClick?.(event),
    "aria-label": primary.label,
    tabIndex: _ModalButtons.MODAL_BUTTON_SELECT_PRIORITIES.primary,
    isLoading: primary.isLoading,
    isDisabled: primary.isDisabled
  }, primary.icon && {
    iconPosition: _Button.BUTTON_ICON_POSITION.left
  }), primary.icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    size: primary.iconSize,
    name: primary.icon
  }), primary.label));
};
exports.ModalButtons = ModalButtons;
//# sourceMappingURL=ModalButtons.js.map